import React, { useState } from "react"
import "./customRadioSelection.styles.css"
import { _$ } from "../../utils/dom"
import { CustomTextField } from "../customTextField/customTextField.component"


export const CustomRadioSelection = ({ heading, inputName, inputIdOne, inputIdTwo, OptionOneValue, OptionTwoValue, isTextRequired, setFieldState, setText }) => {
    const [showTextField, setShowTextField] = useState(false)

    const toggleRadio = (e) => {
        if (e.target.id === inputIdOne) {
            if (isTextRequired) {
                setShowTextField(true)
            }
            setFieldState(1)
            _$(inputIdOne).addClassToParent(3, "checked")
            _$(inputIdTwo).removeClassToParent(3, "checked")
        } else {
            _$(inputIdOne).removeClassToParent(3, "checked")
            _$(inputIdTwo).addClassToParent(3, "checked")
            setShowTextField(false)
            setFieldState(0)
        }
    }

    return (
        <>
            <h2 className="text-uppercase mb-0">
                {heading}
            </h2>
            <div className="row">
                <div className="col-6 col-lg-3">
                    <div className="card">
                        <div className="card-body p-1">
                            <div className="custom-control custom-radio">
                                <input type="radio" id={inputIdOne} name={inputName}
                                    className="custom-control-input" onClick={toggleRadio} />
                                <label className="custom-control-label" htmlFor={inputIdOne}>{OptionOneValue}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-6 col-lg-3">
                    <div className="card checked" >
                        <div className="card-body p-1">
                            <div className="custom-control custom-radio">
                                <input type="radio" id={inputIdTwo} name={inputName} className="custom-control-input" onClick={toggleRadio} defaultChecked />
                                <label className="custom-control-label" htmlFor={inputIdTwo}>{OptionTwoValue}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showTextField && (
                <CustomTextField fieldName={"REMARKS"} setText={setText} />
            )}
        </>
    )
}